export default {
  /* eslint-disable */
  initEvent: function (param) {
    window.webfunnyDomain = param.webfunnyDomain
    window.webfunnyAssetsDomain = param.webfunnyAssetsDomain
    window.CUSTOMER_WEB_EVENT_ID = param.projectId
    sessionStorage.CUSTOMER_WEB_EVENT_ID = param.projectId

    // sdk内容
    var webfunnyGlobal = window
    !(function (n) {
      var r = {}
      function o(e) {
        var t
        return (
          r[e] ||
          ((t = r[e] = { i: e, l: !1, exports: {} }),
          n[e].call(t.exports, t, t.exports, o),
          (t.l = !0),
          t)
        ).exports
      }
      ;((o.m = n),
        (o.c = r),
        (o.d = function (e, t, n) {
          o.o(e, t) || Object.defineProperty(e, t, { enumerable: !0, get: n })
        }),
        (o.r = function (e) {
          ;('undefined' != typeof Symbol &&
            Symbol.toStringTag &&
            Object.defineProperty(e, Symbol.toStringTag, { value: 'Module' }),
            Object.defineProperty(e, '__esModule', { value: !0 }))
        }),
        (o.t = function (t, e) {
          if ((1 & e && (t = o(t)), 8 & e)) return t
          if (4 & e && 'object' == typeof t && t && t.__esModule) return t
          var n = Object.create(null)
          if (
            (o.r(n),
            Object.defineProperty(n, 'default', { enumerable: !0, value: t }),
            2 & e && 'string' != typeof t)
          )
            for (var r in t)
              o.d(
                n,
                r,
                function (e) {
                  return t[e]
                }.bind(null, r)
              )
          return n
        }),
        (o.n = function (e) {
          var t =
            e && e.__esModule
              ? function () {
                  return e.default
                }
              : function () {
                  return e
                }
          return (o.d(t, 'a', t), t)
        }),
        (o.o = function (e, t) {
          return Object.prototype.hasOwnProperty.call(e, t)
        }),
        (o.p = ''),
        o((o.s = 21)))
    })([
      function (e, t, n) {
        'use strict'
        ;(n.d(t, 'p', function () {
          return l
        }),
          n.d(t, 'o', function () {
            return p
          }),
          n.d(t, 'r', function () {
            return h
          }),
          n.d(t, 'c', function () {
            return b
          }),
          n.d(t, 'i', function () {
            return w
          }),
          n.d(t, 'j', function () {
            return g
          }),
          n.d(t, 's', function () {
            return y
          }),
          n.d(t, 'n', function () {
            return v
          }),
          n.d(t, 'g', function () {
            return E
          }),
          n.d(t, 'm', function () {
            return x
          }),
          n.d(t, 'k', function () {
            return T
          }),
          n.d(t, 'e', function () {
            return j
          }),
          n.d(t, 'h', function () {
            return _
          }),
          n.d(t, 'a', function () {
            return S
          }),
          n.d(t, 'b', function () {
            return I
          }),
          n.d(t, 'q', function () {
            return P
          }),
          n.d(t, 'l', function () {
            return C
          }),
          n.d(t, 'f', function () {
            return k
          }))
        var r = n(3),
          s = n.n(r),
          r = n(10),
          u = n.n(r),
          d = (n(24), n(2)),
          o = n(4),
          i = n(6)
        function a(e) {
          return '[object Array]' === Object.prototype.toString.apply(e)
        }
        function c(e) {
          return '[object Object]' === Object.prototype.toString.apply(e)
        }
        function f(e) {
          return (
            !e ||
            'null' === String(e).toLowerCase() ||
            'undefined' === String(e).toLowerCase() ||
            (a(e) && !e.length) ||
            (c((e = e)) && '{}' === JSON.stringify(e))
          )
        }
        function l(e) {
          return !f(e)
        }
        function p() {
          return !(!window || 'undefined' != typeof my)
        }
        function h() {
          var a = {}
          if (p()) {
            var e = window.location.search,
              t = e.indexOf('?')
            if (-1 === t) return a
            e.substring(t + 1)
              .split('&')
              .forEach(function (e) {
                var e = e.split('='),
                  t = decodeURIComponent(e[0]),
                  e = decodeURIComponent(e[1] || ''),
                  n = 0,
                  r = t.split('.'),
                  o = r.length,
                  t = r[o - 1],
                  i = a
                if (1 < o)
                  for (; n < o - 1; n++) ((i[r[n]] && c(i[r[n]])) || (i[r[n]] = {}), (i = i[r[n]]))
                '[]' !== t.substring(-2)
                  ? (i[t] = e)
                  : i[(t = t.substring(0, t.length - 2))]
                    ? i[t].push(e)
                    : (i[t] = [e])
              })
          }
          return a
        }
        function b(e) {
          var t = encodeURIComponent(e)
          try {
            if (p())
              return btoa(
                encodeURIComponent(t).replace(/%([0-9A-F]{2})/g, function (e, t) {
                  return String.fromCharCode('0x' + t)
                })
              )
            for (var n = new Uint8Array(t.length), r = 0; r < t.length; r++) n[r] = t.charCodeAt(r)
            return webfunnyGlobal ? webfunnyGlobal.arrayBufferToBase64(n) : ''
          } catch (e) {
            return t
          }
        }
        function w(e) {
          try {
            var t = document
            return t.evaluate(e, t).iterateNext()
          } catch (e) {
            return null
          }
        }
        function g(e, t) {
          var n,
            t = t || document
          if (((n = t.querySelectorAll), 'undefined' !== s()(n)))
            return t.querySelectorAll('[' + e + ']')
          for (var r = [], o = t.getElementsByTagName('*'), i = 0, a = o.length; i < a; i++) {
            var c = o[i]
            null !== c.getAttribute(e) && r.push(c)
          }
          return r
        }
        function y(e, t) {
          var n,
            r,
            o,
            i,
            a,
            c,
            s,
            u =
              2 < arguments.length && void 0 !== arguments[2]
                ? arguments[2]
                : new Date().getTime() + 2592e6
          try {
            p()
              ? ((n = localStorage),
                (r = { data: t, expires: u }),
                n.WEBFUNNY_COOKIE
                  ? (((o = JSON.parse(n.WEBFUNNY_COOKIE))[e] = r),
                    (n.WEBFUNNY_COOKIE = JSON.stringify(o)))
                  : (((i = {})[e] = r), (n.WEBFUNNY_COOKIE = JSON.stringify(i))))
              : webfunnyGlobal &&
                ((a = { data: t, expires: u }),
                (c = webfunnyGlobal.getStorageSync(d.e))
                  ? (((c = 'string' == typeof c ? JSON.parse(c) : c)[e] = a),
                    webfunnyGlobal.setStorageSync(d.e, c))
                  : (((s = {})[e] = a), webfunnyGlobal.setStorageSync(d.e, s)))
          } catch (e) {}
        }
        function m(e) {
          try {
            var t,
              n,
              r = localStorage,
              o = null
            return r.WEBFUNNY_COOKIE
              ? (t = (o = JSON.parse(r.WEBFUNNY_COOKIE))[e])
                ? (n = parseInt(t.expires, 10)) < new Date().getTime()
                  ? (delete o[e], (r.WEBFUNNY_COOKIE = JSON.stringify(o)), { data: '', expires: 0 })
                  : { data: t.data, expires: n }
                : { data: '', expires: 0 }
              : { data: '', expires: 0 }
          } catch (e) {
            return { data: '', expires: 0 }
          }
        }
        function v(e) {
          try {
            var t = m(e).data
            return void 0 === t ? '' : t
          } catch (e) {
            return ''
          }
        }
        function O() {
          var e = new Date().Format('yyyyMMddhhmmssS')
          return (
            'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (e) {
              var t = (16 * Math[['m', 'o', 'd', 'n', 'a', 'r'].reverse().join('')]()) | 0
              return ('x' == e ? t : (3 & t) | 8).toString(16)
            }) +
            '-' +
            e
          )
        }
        function E() {
          return (
            (e = C()),
            (t = ''),
            (n = O()),
            (r = v('monitorCustomerKeys')),
            (o = new Date().getTime() + 31104e7),
            r
              ? (r = JSON.parse(r))[e]
                ? (t = r[e])
                : ((r[e] = n), y('monitorCustomerKeys', JSON.stringify(r), o), (t = n), 0)
              : (((r = {})[e] = n), y('monitorCustomerKeys', JSON.stringify(r), o), (t = n), 0),
            t
          )
          var e, t, n, r, o
        }
        function x(e) {
          var t,
            n = ''
          try {
            if (p()) {
              if (!e) return ''
              var r = v('wfEventUserInfo')
              if (!r) return ''
              var o = JSON.parse(r),
                i = C()
              if (!o[i]) return ''
              n = o[i][e]
            } else {
              if (!e) return ''
              webfunnyGlobal &&
                (n = ((t = webfunnyGlobal.getStorageSync('wmUserInfo')) ? JSON.parse(t) : {})[e])
            }
          } catch (e) {}
          return n || ''
        }
        function T() {
          var e,
            t = ''
          return (
            p()
              ? (t =
                  'full' === (0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : '')
                    ? window.location.href
                    : window.location.href.split('?')[0])
              : getCurrentPages &&
                0 < (e = getCurrentPages()).length &&
                (t = getCurrentPages()[e.length - 1].route),
            t
          )
        }
        function j() {
          var e = { newStatus: 1, firstPvDay: new Date().getTime(), accessTimes: 1 }
          try {
            var t,
              n,
              r = '',
              o = 0,
              i = (function () {
                var e = 1
                try {
                  var t = v(d.d)
                  t && (e = +JSON.parse(t).count)
                } catch (e) {}
                return e
              })(),
              a = E()
            ;(a
              ? (t = a ? a.match(/\d{14}/g) : []) &&
                0 < t.length &&
                (r =
                  (o = (n = t[0].match(/\d{2}/g))[0] + n[1] + '-' + n[2] + '-' + n[3]) ===
                  new Date().Format(d.b)
                    ? 1
                    : 2)
              : (r = 1),
              (e = { newStatus: r, firstPvDay: o, accessTimes: i }))
          } catch (e) {}
          return e
        }
        function _() {
          var e = {},
            t = navigator.userAgent,
            n = t.match(/(Android);?[\s\/]+([\d.]+)?/),
            r = t.match(/(iPad).*OS\s([\d_]+)/),
            o = !r && t.match(/(iPhone\sOS)\s([\d_]+)/),
            i = t.match(/Android\s[\S\s]+Build\//),
            a = window.screen.width,
            c = window.screen.height
          if (
            ((e.ios = e.android = e.iphone = e.ipad = e.androidChrome = !1),
            (e.isWeixin = /MicroMessenger/i.test(t)),
            (e.os = 'web'),
            (e.deviceName = 'PC'),
            (e.deviceSize = a + '×' + c),
            (e.platform = navigator.platform),
            n &&
              ((e.os = 'android'),
              (e.osVersion = n[2]),
              (e.android = !0),
              (e.androidChrome = 0 <= t.toLowerCase().indexOf('chrome'))),
            (r || o) && ((e.os = 'ios'), (e.ios = !0)),
            o && ((e.osVersion = o[2].replace(/_/g, '.')), (e.iphone = !0)),
            r && ((e.osVersion = r[2].replace(/_/g, '.')), (e.ipad = !0)),
            e.ios &&
              e.osVersion &&
              0 <= t.indexOf('Version/') &&
              '10' === e.osVersion.split('.')[0] &&
              (e.osVersion = t.toLowerCase().split('version/')[1].split(' ')[0]),
            e.iphone)
          ) {
            ;((n = ''.concat(a, ' x ').concat(c)),
              (n =
                320 === a && 480 === c
                  ? '4'
                  : 320 === a && 568 === c
                    ? '5/SE'
                    : 375 === a && 667 === c
                      ? '6/7/8'
                      : 414 === a && 736 === c
                        ? '6/7/8 Plus'
                        : 375 === a && 812 === c
                          ? 'X/S/Max'
                          : 414 === a && 896 === c
                            ? '11/Pro-Max'
                            : 375 === a && 812 === c
                              ? '11-Pro/mini'
                              : 390 === a && 844 === c
                                ? '12/13/Pro'
                                : 428 === a && 926 === c
                                  ? '12/13/Pro-Max'
                                  : 390 === a && 844 === c
                                    ? '14/15/Pro'
                                    : 430 === a && 932 === c
                                      ? '14/15/Pro-Max'
                                      : ''))
            e.deviceName = 'iphone ' + n
          } else if (e.ipad) e.deviceName = 'ipad'
          else if (i) {
            for (var s = i[0].split(';'), u = '', d = 0; d < s.length; d++)
              -1 != s[d].indexOf('Build') && (u = s[d].replace(/Build\//g, ''))
            ;('' == u && (u = s[1]), (e.deviceName = u.replace(/(^\s*)|(\s*$)/g, '')))
          }
          o = { browserName: 'unknown', browserVersion: 'unknown' }
          try {
            var f = navigator.userAgent.toLowerCase(),
              l = ''
            0 < f.indexOf('msie')
              ? ((l = f.match(/msie [\d.]+;/gi)[0]),
                (o.browserName = 'ie'),
                (o.browserVersion = l.split('/')[1]))
              : 0 < f.indexOf('edg')
                ? ((l = f.match(/edg\/[\d.]+/gi)[0]),
                  (o.browserName = 'edge'),
                  (o.browserVersion = l.split('/')[1]))
                : 0 < f.indexOf('firefox')
                  ? ((l = f.match(/firefox\/[\d.]+/gi)[0]),
                    (o.browserName = 'firefox'),
                    (o.browserVersion = l.split('/')[1]))
                  : 0 < f.indexOf('safari') && f.indexOf('chrome') < 0
                    ? ((l = f.match(/safari\/[\d.]+/gi)[0]),
                      (o.browserName = 'safari'),
                      (o.browserVersion = l.split('/')[1]))
                    : 0 < f.indexOf('chrome') &&
                      ((l = f.match(/chrome\/[\d.]+/gi)[0]),
                      (o.browserName = 'chrome'),
                      (o.browserVersion = l.split('/')[1]),
                      0 < f.indexOf('360se')) &&
                      (o.browserName = '360')
          } catch (e) {}
          return {
            deviceName: e.deviceName,
            system: ''.concat(e.os, ' ').concat(e.osVersion || ''),
            os: e.os,
            platform: e.platform,
            browserName: o.browserName,
            browserVersion: o.browserVersion
          }
        }
        function S(e, t, n) {
          e.addEventListener
            ? e.addEventListener(t, n, !1)
            : e.attachEvent
              ? e.attachEvent('on' + t, n)
              : (e['on' + t] = n)
        }
        function I(e) {
          i.a.addTask(o.a.trackUrl, e)
        }
        function P(e) {
          var t = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : null,
            n = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : '',
            r = document.getElementsByTagName('head')[0],
            o = null
          ;(o = n ? document.getElementById(n) : o)
            ? t && t()
            : (((o = document.createElement('script')).src = e),
              n && o.setAttribute('id', n),
              (o.type = 'text/javascript'),
              r.appendChild(o),
              (o.onload = function () {
                t && t()
              }))
        }
        function N(e, t) {
          t = 1 < arguments.length && void 0 !== t ? t : 'weRelationPointId'
          try {
            var n = (v('weInitConfig') || {}).sessionTime,
              r = void 0 === n ? 20 : n,
              o = new Date().getTime() + 60 * r * 1e3,
              i = m(t) || {},
              a = i.data,
              c = i.expires,
              s = a
            return (
              s
                ? (1e3 <= s.length
                    ? -1 === s.indexOf('~wf~【too long】') && (s = ''.concat(s, '~wf~【too long】'))
                    : (s = ''.concat(s, '~wf~').concat(e)),
                  y(t, s, c))
                : y(t, e, o),
              b(a)
            )
          } catch (e) {
            return ''
          }
        }
        function C() {
          var e = d.c,
            t = '',
            t = (p() && (sessionStorage.CUSTOMER_WEB_EVENT_ID || window.CUSTOMER_WEB_EVENT_ID)) || e
          return (t = /^event\d*(_\d{8}_\d{7,9}(_[a-z]{3,4})?)$/.test(t) ? t : e)
        }
        function k(e) {
          return (v('initPoints') ? JSON.parse(v('initPoints')) : {})[e]
        }
        t.d = {
          isString: function (e) {
            return '[object String]' === Object.prototype.toString.apply(e)
          },
          isNumber: function (e) {
            return '[object Number]' === Object.prototype.toString.apply(e)
          },
          isArray: a,
          isObject: c,
          isDate: function (e) {
            return '[object Date]' === Object.prototype.toString.apply(e)
          },
          isBoolean: function (e) {
            return '[object Boolean]' === Object.prototype.toString.apply(e)
          },
          getUuid: O,
          getWfCookie: v,
          setWfCookie: y,
          b64Code: b,
          getPath: T,
          getXPath: function (e) {
            try {
              for (var t = e.target, n = []; t.nodeType === Node.ELEMENT_NODE; ) {
                var r = t.nodeName.toLowerCase(),
                  o = (function (e, t) {
                    for (var n = 0; e; )
                      (e.nodeName.toLowerCase() === t && (n += 1), (e = e.previousElementSibling))
                    return n
                  })(t, r)
                ;(n.push(
                  ''.concat(t.tagName.toLowerCase()).concat(1 === o ? '' : '['.concat(o, ']'))
                ),
                  (t = t.parentNode))
              }
              return '/'.concat(n.reverse().join('/'))
            } catch (e) {
              return ''
            }
          },
          getEleByXpath: w,
          combineObject: function (e, t) {
            return u()(e, t)
          },
          getCustomerKey: E,
          getLastHeartBeatTime: function (e) {
            var t = new Date().getTime(),
              n = v('lastHearBeatTime')
            return (
              (n && 1 !== e) || (y('lastHearBeatTime', t, t + d.a.HEART_RATE + 5e3), (n = t)),
              n
            )
          },
          getWeUserInfo: x,
          setFirstActionTime: function (e) {
            for (
              var t = v('weFunnelConfig').funnelList, n = void 0 === t ? [] : t, r = 0;
              r < n.length;
              r++
            ) {
              var o = n[r],
                i = o.s,
                i = void 0 === i ? '' : i,
                a = o.c,
                a = void 0 === a ? '' : a,
                o = o.t,
                o = void 0 === o ? 1 : o,
                o = new Date().getTime() + 24 * o * 3600 * 1e3
              ;-1 !== i.indexOf(+e) &&
                ((i = new Date().Format('yyyyMMdd')),
                y(''.concat(a, '-FirstStepDay'), ''.concat(a, '-').concat(i), o))
            }
          },
          getFirstActionTime: function (e) {
            for (
              var t = v('weFunnelConfig').funnelList, n = void 0 === t ? [] : t, r = '', o = 0;
              o < n.length;
              o++
            ) {
              var i = n[o],
                a = i.s,
                a = void 0 === a ? '' : a,
                i = i.c,
                i = void 0 === i ? '' : i
              ;-1 !== a.indexOf(+e) && (r += v(''.concat(i, '-FirstStepDay')) + ',')
            }
            return r
          },
          addTask: I,
          fireTasks: function () {
            i.a.fireTasks()
          },
          getAccessInfo: j,
          recordAccessTimes: function () {
            var e = d.d,
              t = new Date().getTime() + 316224e5
            try {
              var n,
                r,
                o,
                i,
                a = v(e)
              a
                ? ((n = new Date().Format(d.b)),
                  (i = void 0 === (o = (r = JSON.parse(a)).count) ? 1 : o),
                  n !== r.lastDate &&
                    y(e, JSON.stringify({ count: +i + 1, lastDate: new Date().Format(d.b) }), t))
                : y(e, JSON.stringify({ count: 1, lastDate: new Date().Format(d.b) }), t)
            } catch (e) {}
          },
          getCurrPage: function () {
            var t = {}
            try {
              var e = getCurrentPages()
              0 < e.length && (t = e[e.length - 1])
            } catch (e) {
              t = {}
            }
            return t
          },
          addWeRelationFiled: function (t, e, n) {
            try {
              var r,
                o,
                i,
                a = t.projectId,
                c = t.pointId,
                s = {}
              return (
                !0 === e &&
                  ((r = t.pointId), (o = N(r, 'weRelationPointId')), (s.weRelationPointId = o)),
                n &&
                  ((i = N(t[n], 'weRelationField-'.concat(a, '-').concat(c))),
                  (s.weRelationField = i)),
                u()(t, s)
              )
            } catch (e) {
              return t
            }
          },
          getProjectId: C,
          getCommonPointId: k,
          isH5: p
        }
      },
      function (e, t, n) {
        'use strict'
        t.a = { mouseStayInfo: '', stayTime: 0, uploadStayTimes: 0, timerStatus: 'on' }
      },
      function (e, t, n) {
        'use strict'
        ;(n.d(t, 'c', function () {
          return r
        }),
          n.d(t, 'a', function () {
            return o
          }),
          n.d(t, 'f', function () {
            return i
          }),
          n.d(t, 'e', function () {
            return a
          }),
          n.d(t, 'd', function () {
            return c
          }),
          n.d(t, 'b', function () {
            return s
          }))
        var t = n(3),
          r = 'event_20260401_140749841_pro',
          o = { HEART_RATE: 15e3, MOUSE_STAY_LIMIT: 2e3 },
          i =
            'object' === ('undefined' == typeof navigator ? 'undefined' : n.n(t)()(navigator)) &&
            'Microsoft Internet Explorer' == navigator.appName &&
            parseInt(navigator.appVersion.split(';')[1].replace(/[ ]/g, '').replace('MSIE', '')) <=
              9,
          a = 'WEBFUNNY_COOKIE',
          c = 'webfunny_access_times',
          s = 'yyyy-MM-dd'
      },
      function (t, e) {
        function n(e) {
          return (
            (t.exports = n =
              'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator
                ? function (e) {
                    return typeof e
                  }
                : function (e) {
                    return e &&
                      'function' == typeof Symbol &&
                      e.constructor === Symbol &&
                      e !== Symbol.prototype
                      ? 'symbol'
                      : typeof e
                  }),
            (t.exports.__esModule = !0),
            (t.exports.default = t.exports),
            n(e)
          )
        }
        ;((t.exports = n), (t.exports.__esModule = !0), (t.exports.default = t.exports))
      },
      function (e, t, n) {
        'use strict'
        var n = n(0),
          r = webfunnyGlobal.webfunnyDomain || '//221.6.15.90:9011',
          o = webfunnyGlobal.webfunnyAssetsDomain || '//221.6.15.90:9010',
          i = '',
          i = Object(n.o)() && 0 === r.length ? webfunnyGlobal.location.origin : r
        t.a = {
          trackUrl: ''.concat(i, 'wfEvent/upEvents'),
          marqueeTrackUrl: ''.concat(i, 'wfEvent/buryPointVisualTracking/create'),
          screenShotUploadUrl: ''.concat(i, 'wfEvent/screenShot/upload'),
          eventDomain: i,
          requestMethod: 'POST',
          visualJsUrl: ''.concat(o, 'wf_assets/event/wfVisual.js'),
          screenShotJsUrl: ''.concat(o, 'wf_assets/screenShot/html2canvas.min.js')
        }
      },
      function (e, t, n) {
        'use strict'
        ;(n.d(t, 'a', function () {
          return a
        }),
          n.d(t, 'd', function () {
            return u
          }),
          n.d(t, 'b', function () {
            return d
          }),
          n.d(t, 'c', function () {
            return f
          }))
        var r = n(4),
          c = n(0),
          o = n(11),
          i = n(6),
          s = n(13)
        function a() {
          var e,
            t = r.a.eventDomain
          return !Object(c.o)() ||
            ((e = (e = window.location.protocol).replace(/file/g, 'http')), -1 < t.indexOf('http'))
            ? t
            : e + t
        }
        function u(e, t, n, r, o) {
          if (Object(c.o)())
            try {
              var i = window.XMLHttpRequest
                  ? new XMLHttpRequest()
                  : new ActiveXObject('Microsoft.XMLHTTP'),
                a =
                  (i.open(e, t, !0),
                  i.setRequestHeader('Content-Type', 'application/json;charset=UTF-8'),
                  i.setRequestHeader('wf-signature', Object(s.a)()),
                  (i.onreadystatechange = function () {
                    if (4 == i.readyState) {
                      var t = {}
                      try {
                        t = i.responseText ? JSON.parse(i.responseText) : {}
                      } catch (e) {
                        t = {}
                      }
                      try {
                        'function' == typeof r && r(t)
                      } catch (e) {}
                    }
                  }),
                  (i.onerror = function (e) {
                    try {
                      'function' == typeof o && o()
                    } catch (e) {}
                  }),
                  JSON.stringify(n || {}))
              i.send(a)
            } catch (e) {}
        }
        function d(e) {
          new o.a(r.a.trackUrl).sendByXhr([e])
        }
        function f(e) {
          i.a.addTask(r.a.trackUrl, e)
        }
      },
      function (e, t, n) {
        'use strict'
        var r = n(8),
          o = n.n(r),
          r = n(9),
          i = n.n(r),
          a = n(11),
          c = n(1),
          s = n(0),
          u = null,
          r = (function () {
            function e() {
              ;(o()(this, e), (this.uploadUrl = ''), (this.queues = []))
            }
            return (
              i()(e, [
                {
                  key: 'start',
                  value: function () {
                    var e,
                      t = this
                    u ||
                      ((e = 0),
                      (u = setInterval(function () {
                        ;((40 <= e || 20 < t.queues.length) && (t.fireTasks(), (e = 0)), e++)
                      }, 200)),
                      this.finallyFireTasks())
                  }
                },
                {
                  key: 'addTask',
                  value: function (e, t) {
                    ;((this.uploadUrl = e), this.queues.push(t))
                  }
                },
                {
                  key: 'fireTasks',
                  value: function () {
                    var e = Object(s.r)().webfunnyHeatMap
                    ;('1' === (void 0 === e ? 0 : e)
                      ? (c.a.stayTime = 0)
                      : this.queues &&
                        0 < this.queues.length &&
                        new a.a(this.uploadUrl).sendByXhr(this.queues),
                      (this.queues = []))
                  }
                },
                {
                  key: 'finallyFireTasks',
                  value: function () {
                    var n = this
                    Object(s.o)() &&
                      window.addEventListener('beforeunload', function () {
                        try {
                          var e,
                            t = Object(s.r)().webfunnyHeatMap
                          '1' === (void 0 === t ? 0 : t)
                            ? ((c.a.stayTime = 0), (n.queues = []))
                            : (c.a.stayTime &&
                                ((e = Object(s.f)('heatBeat')) &&
                                  webfunnyGlobal
                                    .webfunnyEvent(e)
                                    .trackEvent({ stayTime: c.a.stayTime }),
                                (c.a.stayTime = 0)),
                              n.queues.length &&
                                (new a.a(n.uploadUrl).sendByBeacon(n.queues), (n.queues = [])))
                        } catch (e) {}
                      })
                  }
                }
              ]),
              e
            )
          })()
        t.a = new r()
      },
      function (e, t, n) {
        'use strict'
        ;(n.d(t, 'a', function () {
          return o
        }),
          n.d(t, 'd', function () {
            return i
          }),
          n.d(t, 'b', function () {
            return a
          }),
          n.d(t, 'c', function () {
            return c
          }))
        var t = n(10),
          l = n.n(t),
          f = n(6),
          p = n(1),
          r = n(5),
          h = n(0),
          o = function (t) {
            var e = Object(h.m)('userId'),
              n = Object(h.m)('nickname')
            Object(r.d)(
              'post',
              Object(r.a)() + 'wfEvent/initCf',
              { projectId: Object(h.l)(), userId: e, nickname: n },
              function (e) {
                t(e.data)
              },
              function () {}
            )
          },
          i = function (e, t, n, r, o) {
            var i = l()({}, t)
            try {
              e.webfunnyEventUtils.setFirstActionTime(o)
              var a,
                c = e.webfunnyEventUtils.getFirstActionTime(o),
                s = e.webfunnyEventGetCustomerInfo()
              for (a in i) 'number' != typeof i[a] && (i[a] = e.webfunnyEventUtils.b64Code(i[a]))
              ;(e.webfunnyEventUtils.combineObject(i, {
                projectId: r,
                pointId: o,
                weHappenTime: new Date().getTime()
              }),
                e.webfunnyEventUtils.combineObject(i, s),
                e.webfunnyEventUtils.combineObject(i, { weFirstStepDay: c }))
              var u = n && n.originField ? n.originField : '',
                d = (n && n.pointIdRelation) || !1,
                f = e.webfunnyEventUtils.addWeRelationFiled(i, d, u)
              ;(e.webfunnyEventUtils.addTask(f),
                n && !0 === n.upNow && e.webfunnyEventUtils.fireTasks())
            } catch (e) {}
          }
        function b() {
          try {
            var e
            p.a.stayTime <= 2 ||
              ((e = Object(h.f)('heatBeat')) &&
                webfunnyGlobal
                  .webfunnyEvent(e)
                  .trackEvent({ stayTime: p.a.stayTime }, { upNow: !0 }),
              (p.a.stayTime = 0),
              p.a.uploadStayTimes ? (p.a.uploadStayTimes += 1) : (p.a.uploadStayTimes = 1))
          } catch (e) {}
        }
        var a = function () {
            var r, o, i
            ;((r = function (e) {
              var t = { 5: ['0', '5'], 15: ['00', '15', '30', '45'], 30: ['00', '30'], 60: ['00'] }
              try {
                var n,
                  r,
                  o,
                  i,
                  a,
                  c,
                  s,
                  u = e.Format('mm:ss'),
                  d =
                    (p.a.stayTime ? (p.a.stayTime += 1) : (p.a.stayTime = 1),
                    JSON.parse(Object(h.n)('wfEventSetting') || '{}'))
                d.heartBeat
                  ? ((o = void 0 === (r = (n = d.heartBeat).enable) || r),
                    (a = void 0 === (i = n.gap) ? 15 : i),
                    !1 !== o &&
                      ((c = 5 == a ? u.substring(4) : u.substring(3)),
                      (s = t[15]),
                      -1 != (s = t[a] ? t[a] : s).indexOf(c)) &&
                      (b(), f.a.fireTasks()))
                  : -1 != t[15].indexOf(u.substring(3)) && (b(), f.a.fireTasks())
              } catch (e) {}
            }),
              (o = new Date().getTime()),
              (i = 0),
              setTimeout(function e() {
                i++
                var t = new Date(),
                  n = 1e3 - (new Date().getTime() - (o + 1e3 * i))
                n < 0 && (n = 0)
                try {
                  r(t)
                } catch (e) {}
                0 < n ? ((p.a.timerStatus = 'on'), setTimeout(e, n)) : (p.a.timerStatus = 'off')
              }, 1e3))
          },
          c = function () {
            ;(f.a.finallyFireTasks(), a())
          }
      },
      function (e, t) {
        ;((e.exports = function (e, t) {
          if (!(e instanceof t)) throw new TypeError('Cannot call a class as a function')
        }),
          (e.exports.__esModule = !0),
          (e.exports.default = e.exports))
      },
      function (e, t, n) {
        var o = n(17)
        function r(e, t) {
          for (var n = 0; n < t.length; n++) {
            var r = t[n]
            ;((r.enumerable = r.enumerable || !1),
              (r.configurable = !0),
              'value' in r && (r.writable = !0),
              Object.defineProperty(e, o(r.key), r))
          }
        }
        ;((e.exports = function (e, t, n) {
          return (
            t && r(e.prototype, t),
            n && r(e, n),
            Object.defineProperty(e, 'prototype', { writable: !1 }),
            e
          )
        }),
          (e.exports.__esModule = !0),
          (e.exports.default = e.exports))
      },
      function (e, t) {
        function n() {
          return (
            (e.exports = n =
              Object.assign
                ? Object.assign.bind()
                : function (e) {
                    for (var t = 1; t < arguments.length; t++) {
                      var n,
                        r = arguments[t]
                      for (n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n])
                    }
                    return e
                  }),
            (e.exports.__esModule = !0),
            (e.exports.default = e.exports),
            n.apply(this, arguments)
          )
        }
        ;((e.exports = n), (e.exports.__esModule = !0), (e.exports.default = e.exports))
      },
      function (e, t, n) {
        'use strict'
        var r = n(3),
          o = n.n(r),
          r = n(8),
          i = n.n(r),
          r = n(9),
          a = n.n(r),
          c = n(5),
          s = n(0),
          u = n(13)
        t.a = (function () {
          function t(e) {
            ;(i()(this, t), (this.url = e))
          }
          return (
            a()(
              t,
              [
                {
                  key: 'sendByXhr',
                  value: function (e) {
                    if (this.url)
                      try {
                        s.d.isH5()
                          ? Object(c.d)(
                              'post',
                              this.url,
                              e,
                              function (e) {
                                t.handleAjaxRes('success', e)
                              },
                              function () {
                                t.handleAjaxRes('error')
                              }
                            )
                          : webfunnyGlobal &&
                            webfunnyGlobal.request({
                              url: this.url,
                              data: e,
                              method: 'POST',
                              header: {
                                'content-type': 'application/json; charset=UTF-8',
                                'wf-signature': Object(u.a)()
                              },
                              success: function (e) {
                                e && e.data && t.handleAjaxRes('success', e.data)
                              }
                            })
                      } catch (e) {}
                  }
                },
                {
                  key: 'sendByBeacon',
                  value: function (e) {
                    this.url &&
                      (window.navigator && 'function' == typeof navigator.sendBeacon
                        ? navigator.sendBeacon(this.url, JSON.stringify(e))
                        : this.sendByXhr(e))
                  }
                }
              ],
              [
                {
                  key: 'handleAjaxRes',
                  value: function (e, t) {
                    'success' === e &&
                      t.data &&
                      'object' === o()(t.data) &&
                      (e = t.data.signature) &&
                      s.d.setWfCookie('webfunnyWeSignature', e, new Date().getTime() + 864e5)
                  }
                }
              ]
            ),
            t
          )
        })()
      },
      function (e, t, n) {
        'use strict'
        n.d(t, 'a', function () {
          return r
        })
        n(5)
        var h = n(0),
          r = function () {
            var e = Object(h.g)(),
              t = Object(h.c)(Object(h.m)('userId')),
              n = Object(h.c)(Object(h.m)('nickname')),
              r = Object(h.c)(Object(h.m)('userType')),
              o = Object(h.c)(Object(h.m)('userTag')),
              i = Object(h.c)(Object(h.m)('des')),
              a = Object(h.h)(),
              c = a.deviceName,
              c = void 0 === c ? '' : c,
              s = a.system,
              s = void 0 === s ? '' : s,
              u = a.os,
              u = void 0 === u ? '' : u,
              d = a.platform,
              d = void 0 === d ? '' : d,
              f = a.browserName,
              f = void 0 === f ? '' : f,
              a = a.browserVersion,
              a = void 0 === a ? '' : a,
              l = Object(h.c)(Object(h.k)()),
              p = Object(h.m)('platform'),
              p = p || d,
              d = Object(h.e)().newStatus,
              d = void 0 === d ? 1 : d
            return {
              weCustomerKey: e,
              weUserId: t,
              weNickname: n,
              weUserType: r,
              weUserLabel: o,
              weRemark: i,
              wePath: l,
              weDeviceName: c,
              wePlatform: p,
              weSystem: s,
              weOs: u,
              weBrowserName: f + ':' + a,
              weBrowserInfo: Object(h.c)(navigator.userAgent),
              weNewStatus: d
            }
          }
      },
      function (e, t, n) {
        'use strict'
        n.d(t, 'a', function () {
          return o
        })
        var r = n(0)
        function o() {
          var e = ''
          try {
            if (!(e = Object(r.n)('webfunnyWeSignature') || '')) return ''
            var t = (function (e) {
                var t = ''
                try {
                  var n = e.split(''),
                    r = n[2],
                    o = ((n[2] = n[21]), (n[21] = r), n[5]),
                    i = ((n[5] = n[18]), (n[18] = o), n[9]),
                    a = ((n[9] = n[15]), (n[15] = i), n[12]),
                    c = ((n[12] = n[31]), (n[31] = a), n[16]),
                    s = ((n[16] = n[28]), (n[28] = c), n[20])
                  ;((n[20] = n[25]), (n[25] = s), (t = n.reverse().join('')))
                } catch (e) {}
                return t
              })(e),
              n = ''.concat(t, ':').concat(Object(r.l)()),
              e = (function (e) {
                var t = 0
                try {
                  for (var n = 0; n < e.length; n++) {
                    t = (t << 5) - t + e.charCodeAt(n)
                    t |= 0
                  }
                } catch (e) {}
                return t
              })(n).toString(16)
          } catch (e) {}
          return e
        }
      },
      function (e, t, n) {
        var r = n(17)
        ;((e.exports = function (e, t, n) {
          return (
            (t = r(t)) in e
              ? Object.defineProperty(e, t, {
                  value: n,
                  enumerable: !0,
                  configurable: !0,
                  writable: !0
                })
              : (e[t] = n),
            e
          )
        }),
          (e.exports.__esModule = !0),
          (e.exports.default = e.exports))
      },
      function (e, t, n) {
        'use strict'
        ;(n.d(t, 'a', function () {
          return P
        }),
          n.d(t, 'c', function () {
            return C
          }),
          n.d(t, 'b', function () {
            return R
          }))
        var t = n(14),
          r = n.n(t),
          w = (n(26), n(0)),
          o =
            (Object(w.o)() &&
              null == Element.prototype.getAttributeNames &&
              (Element.prototype.getAttributeNames = function () {
                for (var e = this.attributes, t = e.length, n = new Array(t), r = 0; r < t; r++)
                  n[r] = e[r].name
                return n
              }),
            function (e, t) {
              if ('function' == typeof e.getAttributeNames && -1 < e.getAttributeNames().indexOf(t))
                return !0
            }),
          i = function (e) {
            Object.prototype.hasOwnProperty.call(e.dataset, 'webfunnyExposureEle') ||
              (e.dataset.webfunnyExposureEle = '')
          },
          a = function (e) {
            return !!Object.prototype.hasOwnProperty.call(e.dataset, 'webfunnyExposureEle')
          },
          h = function (e) {
            Object.prototype.hasOwnProperty.call(e.dataset, 'webfunnyMarqueeClickEle') ||
              (e.dataset.webfunnyMarqueeClickEle = '')
          },
          b = function (e) {
            return !!Object.prototype.hasOwnProperty.call(e.dataset, 'webfunnyMarqueeClickEle')
          },
          g = n(1),
          y = n(2),
          f = n(7)
        function c(t, e) {
          var n,
            r = Object.keys(t)
          return (
            Object.getOwnPropertySymbols &&
              ((n = Object.getOwnPropertySymbols(t)),
              e &&
                (n = n.filter(function (e) {
                  return Object.getOwnPropertyDescriptor(t, e).enumerable
                })),
              r.push.apply(r, n)),
            r
          )
        }
        function m(t) {
          for (var e = 1; e < arguments.length; e++) {
            var n = null != arguments[e] ? arguments[e] : {}
            e % 2
              ? c(Object(n), !0).forEach(function (e) {
                  r()(t, e, n[e])
                })
              : Object.getOwnPropertyDescriptors
                ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n))
                : c(Object(n)).forEach(function (e) {
                    Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e))
                  })
          }
          return t
        }
        var l = 0
        n(3)
        t = ['svg', 'path', 'g', 'image', 'text', 'line', 'rect', 'polygon', 'circle', 'ellipse']
        ;['html', 'body'].concat(t)
        function v(e) {
          var t = document
          return t.evaluate(e, t).iterateNext()
        }
        var O = n(12)
        function s(t, e) {
          var n,
            r = Object.keys(t)
          return (
            Object.getOwnPropertySymbols &&
              ((n = Object.getOwnPropertySymbols(t)),
              e &&
                (n = n.filter(function (e) {
                  return Object.getOwnPropertyDescriptor(t, e).enumerable
                })),
              r.push.apply(r, n)),
            r
          )
        }
        function E(t) {
          for (var e = 1; e < arguments.length; e++) {
            var n = null != arguments[e] ? arguments[e] : {}
            e % 2
              ? s(Object(n), !0).forEach(function (e) {
                  r()(t, e, n[e])
                })
              : Object.getOwnPropertyDescriptors
                ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n))
                : s(Object(n)).forEach(function (e) {
                    Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e))
                  })
          }
          return t
        }
        var d = {},
          u = [],
          p = '_webfunny-eo',
          x = '_webfunny-ce',
          T = function () {
            var e = document.getElementsByTagName('*')
            ;(Array.prototype.forEach.call(e, function (e, t) {
              var n, r
              o(e, p) &&
                (u.push(e), (n = e.getAttribute(p))) &&
                ((e = e),
                (r = t),
                Object.prototype.hasOwnProperty.call(e.dataset, 'exposureKey'.concat(r)) ||
                  (e.dataset['exposureKey'.concat(r)] = ''),
                Object.defineProperty(d, 'data-exposure-key'.concat(t), {
                  value: JSON.parse(n),
                  configureable: !0,
                  writable: !0,
                  enumerable: !0
                }))
            }),
              (u = u.reduce(function (e, t) {
                return (-1 === e.indexOf(t) && e.push(t), e)
              }, [])))
          },
          j = function () {
            ;(T(),
              u.forEach(function (e) {
                a(e) || (i(e), I(e))
              }))
          }
        function _(e) {
          var t
          Object.prototype.hasOwnProperty.call(e, 'pointId') &&
            ((t = e.pointId), Object.prototype.hasOwnProperty.call(window._webfunnyEvent, t)) &&
            (delete e.pointId, window._webfunnyEvent[t].trackEvent(e))
        }
        function S() {
          MutationObserver &&
            new MutationObserver(function (e) {
              for (var t = 0, n = e.length; t < n; t++)
                (e[t].addedNodes[0] && o(e[t].addedNodes[0], p) && j(),
                  e[t].target.querySelector('['.concat(p, ']')) &&
                    !a(e[t].target.querySelector('['.concat(p, ']'))) &&
                    j(),
                  e[t].attributeName === p && e[t].target.attributes[p] && j())
              ;(C(), P())
            }).observe(document.documentElement, { childList: !0, attributes: !0, subtree: !0 })
        }
        var I = function (n) {
          var e,
            t = 0
          o(n, '_webfunny-eo-ratio') &&
            ((e = n.getAttribute('_webfunny-eo-ratio')),
            (t = Object.is(e, '0') ? 0 : parseFloat(e)))
          new IntersectionObserver(
            function (e, t) {
              e.forEach(function (e) {
                0 < e.intersectionRatio &&
                  ((e = Object.keys(n.dataset).find(function (e) {
                    if (-1 < e.indexOf('exposureKey')) return e
                  })) && ((e = 'data-exposure-key' + e.slice(11)), _(d[e])),
                  t.disconnect())
              })
            },
            { root: null, rootMargin: '0px', threshold: t }
          ).observe(n)
        }
        function P() {
          var p = N('click')
          Object(w.p)(p) &&
            setTimeout(function () {
              for (
                var e = function () {
                    var e = p[l],
                      t = e.xPath,
                      n = e.happenPage,
                      r = e.path,
                      o = e.replacePointIdKey,
                      i = e.pointId,
                      e = e.projectId,
                      a = null,
                      n = (('current' !== n || w.d.getPath() === r) && (a = v(t)), document.title),
                      r = t,
                      t = w.d.b64Code(w.d.getPath('full')),
                      c = (document.body ? document.body.scrollWidth : 0) || window.innerWidth,
                      c = c - (c % 20),
                      s = (document.body ? document.body.scrollHeight : 0) || window.innerHeight,
                      u = parseInt(window.devicePixelRatio),
                      d = Object(O.a)(),
                      f = {
                        weTitle: n,
                        weFullPath: t,
                        weXPath: r,
                        weRatio: u,
                        weScrollWidth: c,
                        weScrollHeigh: s,
                        replacePointIdKey: o,
                        projectId: e,
                        pointId: i
                      }
                    a &&
                      !b(a) &&
                      (Object(w.a)(a, 'click', function (e) {
                        var t = parseInt(e.pageX),
                          e = parseInt(e.pageY),
                          t = E(E({}, f), {}, { wePageX: t, wePageY: e }, d)
                        Object(w.b)(t)
                      }),
                      h(a))
                  },
                  l = 0,
                  t = p.length;
                l < t;
                l++
              )
                e()
            }, 500)
        }
        function N(e) {
          var t = 0 < arguments.length && void 0 !== e ? e : 'exposure',
            e = (Object(w.n)('weInitConfig') || {}).marquee,
            e = void 0 === e ? [] : e,
            n = []
          return (n = e.length
            ? e.filter(function (e) {
                return e.eventType === t
              })
            : n)
        }
        var C = function () {
            setTimeout(function () {
              var e = N('exposure')
              e.length &&
                e.forEach(function (e, t) {
                  var n,
                    r,
                    o = e.xPath,
                    i = e.happenPage,
                    a = e.path,
                    c = e.replacePointIdKey,
                    s = e.pointId,
                    e = e.projectId,
                    u = null
                  ;(u = 'current' !== i || w.d.getPath() === a ? v(o) : u) &&
                    ((i = u),
                    !Object.prototype.hasOwnProperty.call(
                      i.dataset,
                      'webfunnyMarqueeExposureEle'
                    )) &&
                    ((a = document.title),
                    (i = o),
                    (o = w.d.b64Code(w.d.getPath('full'))),
                    (r =
                      (r = (document.body ? document.body.scrollWidth : 0) || window.innerWidth) -
                      (r % 20)),
                    (n = (document.body ? document.body.scrollHeight : 0) || window.innerHeight),
                    (a = {
                      weTitle: a,
                      weFullPath: o,
                      weXPath: i,
                      weRatio: parseInt(window.devicePixelRatio),
                      weScrollWidth: r,
                      weScrollHeigh: n,
                      replacePointIdKey: c,
                      pointId: s,
                      projectId: e
                    }),
                    (o = u),
                    (i = t),
                    Object.prototype.hasOwnProperty.call(
                      o.dataset,
                      'marqueeExposureKey'.concat(i)
                    ) || (o.dataset['marqueeExposureKey'.concat(i)] = ''),
                    Object.defineProperty(d, 'data-marquee-exposure-key'.concat(t), {
                      value: a,
                      configureable: !0,
                      writable: !0,
                      enumerable: !0
                    }),
                    (r = u),
                    Object.prototype.hasOwnProperty.call(r.dataset, 'webfunnyMarqueeExposureEle') ||
                      (r.dataset.webfunnyMarqueeExposureEle = ''),
                    k(u))
                })
            }, 500)
          },
          k = function (i) {
            var e,
              t = 0
            o(i, '_webfunny-marquee-eo-ratio') &&
              ((e = i.getAttribute('_webfunny-marquee-eo-ratio')),
              (t = Object.is(e, '0') ? 0 : parseFloat(e)))
            new IntersectionObserver(
              function (e, o) {
                e.forEach(function (e) {
                  var t, n, r
                  0 < e.intersectionRatio &&
                    ((r = Object.keys(i.dataset).find(function (e) {
                      if (-1 < e.indexOf('marqueeExposureKey')) return e
                    })) &&
                      ((r = 'data-marquee-exposure-key' + r.slice(18)),
                      (t = e.intersectionRect && e.intersectionRect.x ? e.intersectionRect.x : 0),
                      (t = parseInt(t)),
                      (e = e.intersectionRect && e.intersectionRect.y ? e.intersectionRect.y : 0),
                      (e = parseInt(e)),
                      (n = Object(O.a)()),
                      (r = E(E({}, d[r]), {}, { wePageX: t, wePageY: e }, n)),
                      Object(w.b)(r)),
                    o.disconnect())
                })
              },
              { root: null, rootMargin: '0px', threshold: t }
            ).observe(i)
          },
          R = function () {
            var e
            Object(w.o)() &&
              (j(),
              S(),
              setTimeout(function () {
                for (var e = Object(w.j)(x), t = 0, n = e.length; t < n; t++) {
                  var r = e[t]
                  Object(w.a)(r, 'click', function (e) {
                    e = e.target.getAttribute(x)
                    e && _(JSON.parse(e))
                  })
                }
              }, 500),
              window.addEventListener(
                'click',
                function (e) {
                  if (e) {
                    var t = new Date().getTime()
                    if (t - l < 500) l = t
                    else {
                      ;((l = t),
                        'off' === g.a.timerStatus && ((g.a.timerStatus = 'on'), Object(f.b)()))
                      try {
                        var n = '',
                          r = e.target.tagName,
                          o = '',
                          i =
                            ('svg' != e.target.tagName &&
                              'use' != e.target.tagName &&
                              ((n = e.target.className),
                              (o = (o =
                                100 <
                                (o = e.target.innerText
                                  ? e.target.innerText.replace(/\s*/g, '')
                                  : '').length
                                  ? o.substring(0, 50) +
                                    ' ... ' +
                                    o.substring(o.length - 49, o.length - 1)
                                  : o).replace(/\s/g, ''))),
                            (document.body ? document.body.scrollWidth : 0) || window.innerWidth),
                          a = document.title,
                          c = w.d.b64Code(w.d.getPath()),
                          s = w.d.b64Code(w.d.getPath('full')),
                          u = {
                            weTitle: a,
                            wePath: c,
                            weScrollWidth: i - (i % 20),
                            weScrollHeigh:
                              (document.body ? document.body.scrollHeight : 0) ||
                              window.innerHeight,
                            weXPath: w.d.getXPath(e),
                            weFullPath: s,
                            wePageX: e.pageX,
                            wePageY: e.pageY,
                            weRatio: parseInt(window.devicePixelRatio),
                            className: n,
                            tagName: r,
                            innerText: o
                          },
                          d = w.d.getCommonPointId('click')
                        d && webfunnyGlobal.webfunnyEvent(d).trackEvent(u)
                      } catch (e) {}
                    }
                  }
                },
                !0
              ),
              window.addEventListener(
                'mousemove',
                function (b) {
                  b &&
                    (e && clearTimeout(e),
                    'off' === g.a.timerStatus && ((g.a.timerStatus = 'on'), Object(f.b)()),
                    (e = setTimeout(function () {
                      try {
                        var e,
                          t,
                          n,
                          r,
                          o,
                          i = document.title,
                          a = (document.body ? document.body.scrollWidth : 0) || window.innerWidth,
                          c = w.d.b64Code(w.d.getPath()),
                          s = w.d.b64Code(w.d.getPath('full')),
                          u = a - (a % 20),
                          d =
                            (document.body ? document.body.scrollHeight : 0) || window.innerHeight,
                          f = w.d.getXPath(b),
                          l = b.pageX,
                          p = b.pageY,
                          h = {
                            weTitle: i,
                            wePath: c,
                            weScrollWidth: u,
                            weScrollHeigh: d,
                            weXPath: f,
                            weFullPath: s,
                            wePageX: l,
                            wePageY: p,
                            weRatio: parseInt(window.devicePixelRatio)
                          }
                        g.a.mouseStayInfo
                          ? 150 <
                              (n =
                                (e = new Date().getTime()) -
                                (void 0 === (t = (g.a.mouseStayInfo || {}).startTime) ? 0 : t)) &&
                            ((n = n > y.a.MOUSE_STAY_LIMIT ? y.a.MOUSE_STAY_LIMIT : n),
                            (r = m(m({}, h), {}, { stayTime: n })),
                            (o = w.d.getCommonPointId('mouseStop')) &&
                              webfunnyGlobal.webfunnyEvent(o).trackEvent(r),
                            (g.a.mouseStayInfo = m(m({}, h), {}, { startTime: e })))
                          : (g.a.mouseStayInfo = m(
                              m({}, h),
                              {},
                              { startTime: new Date().getTime() }
                            ))
                      } catch (e) {}
                    }, 200)))
                },
                !0
              ),
              window.addEventListener(
                'mouseout',
                function (e) {
                  'html' === (e.target.tagName ? e.target.tagName.toLowerCase() : '') &&
                    setTimeout(function () {
                      g.a.mouseStayInfo = ''
                    }, 1e3)
                },
                !0
              ))
          }
      },
      function (e, t, n) {
        'use strict'
        var r = n(8),
          o = n.n(r),
          r = n(9),
          i = n.n(r),
          a = n(2),
          c = n(0),
          s = 0,
          u = '',
          r = (function () {
            function t() {
              o()(this, t)
            }
            return (
              i()(
                t,
                [
                  {
                    key: 'recordFirstPv',
                    value: function () {
                      setTimeout(function () {
                        t.recordPv(!0)
                      }, 3e3)
                    }
                  },
                  {
                    key: 'start',
                    value: function () {
                      var r, e
                      !0 !== a.f &&
                        ((e = window),
                        (r = window.history),
                        e.Event &&
                          'function' == typeof e.Event &&
                          ((r.pushState = (e = function (e) {
                            var t = r[e],
                              n = new Event(e)
                            return function () {
                              var e = t.apply(this, arguments)
                              return ((n.arguments = arguments), window.dispatchEvent(n), e)
                            }
                          })('pushState')),
                          (r.replaceState = e('replaceState'))),
                        window.addEventListener('hashchange', function () {
                          setTimeout(function () {
                            t.recordPv(!1)
                          }, 1)
                        }),
                        window.addEventListener('popstate', function () {
                          try {
                            setTimeout(function () {
                              t.recordPv(!1)
                            }, 1)
                          } catch (e) {}
                        }),
                        window.addEventListener('pushState', function (e) {
                          setTimeout(function () {
                            t.recordPv(!1)
                          }, 1)
                        }),
                        window.addEventListener('replaceState', function (e) {
                          setTimeout(function () {
                            t.recordPv(!1)
                          }, 1)
                        }))
                    }
                  }
                ],
                [
                  {
                    key: 'recordPv',
                    value: function (e) {
                      var t
                      window.webfunnyEvent &&
                        !(
                          0 <= (t = new Date().getTime() - s) &&
                          t < 1e3 &&
                          u === window.location.pathname
                        ) &&
                        ((s = new Date().getTime()),
                        (u = window.location.pathname),
                        (t = Object(c.f)('browsing'))) &&
                        window
                          .webfunnyEvent(t)
                          .trackEvent(
                            {
                              wePagePath: window.location.pathname,
                              wePageTitle: document.title,
                              weAccessAddress: window.location.href,
                              weWebsitSource: document.referrer
                            },
                            { upNow: e, pointIdRelation: !0, originField: 'wePagePath' }
                          )
                    }
                  }
                ]
              ),
              t
            )
          })()
        t.a = new r()
      },
      function (e, t, n) {
        var r = n(3).default,
          o = n(25)
        ;((e.exports = function (e) {
          return ((e = o(e, 'string')), 'symbol' == r(e) ? e : String(e))
        }),
          (e.exports.__esModule = !0),
          (e.exports.default = e.exports))
      },
      function (e, t, n) {
        'use strict'
        var s = n(0)
        t.a = {
          init: function (e) {
            try {
              Object(s.s)('currentEventProjectId', Object(s.l)(), new Date().getTime() + 864e5)
              var t = e.projectVersion,
                n = void 0 === t ? '1.0.0' : t,
                r = e.env,
                o = void 0 === r ? 'pro' : r,
                i = e.setting,
                a = void 0 === i ? {} : i,
                c = Object(s.n)('wfEventAppInfo')
              ;(c ? 'string' == typeof c && (c = JSON.parse(c)) : (c = {}),
                (c[Object(s.l)()] = { projectVersion: n }),
                Object(s.s)('wfEventAppInfo', JSON.stringify(c), new Date().getTime() + 2592e6),
                Object(s.s)('wfEventEnv', o, new Date().getTime() + 2592e6),
                Object(s.s)('wfEventSetting', JSON.stringify(a), new Date().getTime() + 2592e6))
            } catch (e) {}
          },
          initUser: function (e) {
            try {
              var t = Object(s.n)('wfEventUserInfo')
              ;(t ? 'string' == typeof t && (t = JSON.parse(t)) : (t = {}),
                (t[Object(s.l)()] = e),
                Object(s.s)('wfEventUserInfo', JSON.stringify(t), new Date().getTime() + 2592e6))
            } catch (e) {}
          },
          getWfCookie: function (e) {
            return Object(s.n)(e)
          },
          setWfCookie: function (e, t, n) {
            Object(s.s)(e, t, n)
          }
        }
      },
      function (e, t, n) {
        'use strict'
        n.d(t, 'a', function () {
          return o
        })
        var r = n(5),
          k = n(0),
          o = function () {
            var e, N, C, t, n
            !0 !== window.WF_EVENT_SHOW_HEATMAP &&
              ((window.WF_EVENT_SHOW_HEATMAP = !0),
              (n = (t = Object(k.r)()).webfunnyHeatMap),
              (e = t.webfunnyCardId),
              (N = t.webfunnyStartTime),
              (C = t.webfunnyEndTime),
              '1' === (void 0 === n ? 0 : n)) &&
              (((t = document.createElement('style')).innerHTML =
                '\n      .webfunny-tip {\n        position: absolute; z-index: 9999;\n        width: 50px; height: 20px; text-align: center; color: #fff; font-size: 12px;line-height: 20px; border-radius: 3px;\n      }\n      .webfunny-triangle {\n        width: 0;height: 0;border-left: 5px solid transparent; border-right: 5px solid transparent;\n        margin-left: 21px;\n      }\n      .webfunny-info {\n        position: absolute;\n        width: 150px;\n        height: auto;\n        background: #333;\n        border-radius: 4px;\n        padding: 5px;\n        left: 50px;\n        margin-top: -25px;\n        text-align: left;\n        color: #fff;\n        background: #fa840c;\n        box-shadow: 1px 0px 7px #fa840c;\n        display: none;\n      }\n      .webfunny-tip:hover .webfunny-info {\n        display: block;\n      }\n    '),
              (n = document.head || document.getElementsByTagName('head')[0]).insertBefore(
                t,
                n.firstChild
              ),
              Object(r.d)(
                'post',
                Object(r.a)() + 'wfEvent/buryPointCard/getHeatMapPerData',
                { webfunnyCardId: e, webfunnyStartTime: N, webfunnyEndTime: C },
                function (e) {
                  try {
                    var t = 'array' == typeof e.data ? e.data : e.data.pathList
                    if (
                      (k.d.setWfCookie('wf_fe_domain', e.data.fe),
                      k.d.setWfCookie('wf_click_pointId', e.data.pointId),
                      t && t.length)
                    ) {
                      for (var n = 0, r = 0, o = 0; o < t.length; o++) {
                        var i = t[o],
                          a = i.count,
                          c = void 0 === a ? 0 : a,
                          s = i.userCount
                        ;((n += +c), (r += +(void 0 === s ? 0 : s)))
                      }
                      for (var u = 0; u < t.length; u++) {
                        var d = t[u],
                          f = d.xPath,
                          l = d.percentage,
                          p = d.count,
                          h = void 0 === p ? 0 : p,
                          b = d.userCount
                        ;((P = I = _ = S = _ = j = T = x = E = O = v = m = y = g = void 0),
                          (m = (w = {
                            xPath: f,
                            percentage: l,
                            count: h,
                            userCount: void 0 === b ? 0 : b,
                            totalCount: n,
                            totalUserCount: r,
                            webfunnyStartTime: N,
                            webfunnyEndTime: C
                          }).xPath),
                          (v = w.percentage),
                          (O = w.count),
                          (E = w.userCount),
                          (x = w.totalCount),
                          (T = w.totalUserCount),
                          (j = w.webfunnyStartTime),
                          (w = w.webfunnyEndTime),
                          (S = _ = ''),
                          50 <= v
                            ? ((_ = '#FFA166'), (S = '#FF8639'))
                            : 10 <= v
                              ? ((_ = '#7A79FF'), (S = '#6D6CE5'))
                              : 0 <= v && ((_ = '#28C989'), (S = '#24B27A')),
                          (_ = ' background: linear-gradient(180deg, '
                            .concat(_, ' 0%, ')
                            .concat(
                              S,
                              ' 116.67%); filter: drop-shadow(0px 2px 6px rgba(0, 0, 0, 0.20));'
                            )),
                          (I = document.createElement('div')),
                          (P = Object(k.i)(m)) &&
                            null !== P &&
                            ((y = (P = P.getBoundingClientRect()).x),
                            (g = P.y),
                            (y = y + P.width / 2 - 25),
                            (P = g - 10),
                            (I.className = 'webfunny-tip'),
                            (I.style = 'top: '.concat(P, 'px; left: ').concat(y, 'px; ').concat(_)),
                            (I.textContent = v + '%'),
                            ((g = document.createElement('div')).className = 'webfunny-triangle'),
                            (g.style = ' border-top: 5px solid '.concat(S, '; ')),
                            I.appendChild(g),
                            (P = k.d.b64Code(m)),
                            (y = k.d.getWfCookie('wf_click_pointId')),
                            (_ = '//'
                              .concat(
                                k.d.getWfCookie('wf_fe_domain'),
                                '/wf_event/eventSearch?projectId='
                              )
                              .concat(Object(k.l)(), '&pointId=')
                              .concat(y, '&xPath=')
                              .concat(P, '&startDate=')
                              .concat(j, '&endDate=')
                              .concat(w)),
                            ((S = document.createElement('div')).className = 'webfunny-info'),
                            (S.innerHTML = '\n  <label>点击次数：'
                              .concat(O, '次</label><br>\n  <label>点击人数：')
                              .concat(E, '人</label><br>\n  <label>点击比例：')
                              .concat(v, '%</label><br>\n  <label>总数：')
                              .concat(x, '次、')
                              .concat(T, '人</label><br>\n  <label><a target="_blank" href="')
                              .concat(_, '" style="color: #fff;">查看详情</a></label>\n  ')),
                            I.appendChild(S),
                            document.body.appendChild(I)))
                      }
                    }
                    window.WF_EVENT_SHOW_HEATMAP = !0
                  } catch (e) {}
                  var w, g, y, m, v, O, E, x, T, j, _, S, I, P
                },
                function () {}
              ))
          }
      },
      function (e, t, n) {
        'use strict'
        n.d(t, 'a', function () {
          return r
        })
        var c = n(0),
          s = n(4)
        function r() {
          var e,
            t,
            n,
            r,
            o,
            i = Object(c.m)('userId'),
            a = Object(c.n)('weInitConfig').userInfo
          a &&
            a.length &&
            (a = a.find(function (e) {
              return e.bindUserId === i
            })) &&
            ((e = a.projectId),
            (t = a.createUserId),
            (n = a.createBy),
            (r = a.bindUserId),
            (o = a.bindBy),
            Object(c.q)(
              s.a.visualJsUrl,
              function () {
                window.wfVisual.init({
                  useShadowDom: !0,
                  defaults: {
                    displaySize: 70,
                    transparency: 0.9,
                    trackUrl: s.a.marqueeTrackUrl,
                    screenShotUploadUrl: s.a.screenShotUploadUrl,
                    projectId: e,
                    bindUserId: r,
                    bindBy: o,
                    ownerUserId: t,
                    ownerName: n
                  }
                })
              },
              'async-wf-visual'
            ),
            window.html2canvas || Object(c.q)(s.a.screenShotJsUrl))
        }
      },
      function (e, t, n) {
        e.exports = n(22)
      },
      function (e, t, p) {
        'use strict'
        ;(p.r(t),
          function (e) {
            var t = p(3),
              o = p.n(t),
              t = p(5),
              n = p(15),
              i = p(0),
              r = p(2),
              a = p(18),
              c = p(7),
              s = p(19),
              u = p(12),
              d = p(20),
              f = p(16),
              l = window || e
            if (!l.webfunnyEventUtils || i.d.getWfCookie('currentEventProjectId') !== r.c)
              try {
                ;((l.WE_INIT_FLG = !1),
                  Object(c.a)(function (e) {
                    ;((l.WE_INIT_FLG = !0),
                      e &&
                        (i.d.setWfCookie('weInitConfig', e, new Date().getTime() + 864e5),
                        i.d.setWfCookie(
                          'webfunnyWeSignature',
                          e.signature,
                          new Date().getTime() + 864e5
                        ),
                        Object(d.a)(),
                        Object(n.a)(),
                        Object(n.c)()),
                      Object(s.a)(),
                      Object(c.c)())
                  }),
                  i.d &&
                    ((l.WebfunnyEvents = a.a),
                    (l.webfunnyEventUtils = i.d),
                    (l.webfunnyEventGetCustomerInfo = u.a),
                    l.webfunnyEventUtils.getCustomerKey(),
                    l.webfunnyEventUtils.getLastHeartBeatTime(1),
                    l.webfunnyEventUtils.recordAccessTimes()),
                  t.c &&
                    ((l.webfunnyEventSendRequest = t.b),
                    (l.webfunnyEventStoreLogs = t.c),
                    (l._webfunnyEvent = function (e) {
                      var t = i.d.getWfCookie('wfEventEnv'),
                        n = 'object' === o()(e) ? e[t] : e,
                        r = i.d.getProjectId()
                      return {
                        fields: {},
                        trackEvent: function (e, t) {
                          ;(t && t.lockedProjectId && (r = t.lockedProjectId),
                            Object(c.d)(l, e, t, r, n))
                        }
                      }
                    })),
                  f.a.recordFirstPv(),
                  f.a.start(),
                  Object(n.b)())
              } catch (e) {}
          }.call(this, p(23)))
      },
      function (e, t) {
        var n = (function () {
          return this
        })()
        try {
          n = n || new Function('return this')()
        } catch (e) {
          'object' == typeof window && (n = window)
        }
        e.exports = n
      },
      function (e, t) {
        Date.prototype.Format ||
          (Date.prototype.Format = function (e) {
            var t,
              n = e,
              r = {
                'M+': this.getMonth() + 1,
                'd+': this.getDate(),
                'h+': this.getHours(),
                'm+': this.getMinutes(),
                's+': this.getSeconds(),
                'q+': Math.floor((this.getMonth() + 3) / 3),
                S: this.getMilliseconds()
              }
            for (t in (/(y+)/.test(n) &&
              (n = n.replace(RegExp.$1, (this.getFullYear() + '').substr(4 - RegExp.$1.length))),
            r))
              new RegExp('(' + t + ')').test(n) &&
                (n = n.replace(
                  RegExp.$1,
                  1 === RegExp.$1.length ? r[t] : ('00' + r[t]).substr(('' + r[t]).length)
                ))
            return n
          })
      },
      function (e, t, n) {
        var r = n(3).default
        ;((e.exports = function (e, t) {
          if ('object' != r(e) || !e) return e
          var n = e[Symbol.toPrimitive]
          if (void 0 === n) return ('string' === t ? String : Number)(e)
          if (((n = n.call(e, t || 'default')), 'object' != r(n))) return n
          throw new TypeError('@@toPrimitive must return a primitive value.')
        }),
          (e.exports.__esModule = !0),
          (e.exports.default = e.exports))
      },
      function (e, t) {
        !(function () {
          'use strict'
          var p, n, h, b
          function i(e) {
            try {
              return (e.defaultView && e.defaultView.frameElement) || null
            } catch (e) {
              return null
            }
          }
          function u(e) {
            ;((this.time = e.time),
              (this.target = e.target),
              (this.rootBounds = r(e.rootBounds)),
              (this.boundingClientRect = r(e.boundingClientRect)),
              (this.intersectionRect = r(e.intersectionRect || d())),
              (this.isIntersecting = !!e.intersectionRect))
            var e = this.boundingClientRect,
              e = e.width * e.height,
              t = this.intersectionRect,
              t = t.width * t.height
            this.intersectionRatio = e ? Number((t / e).toFixed(4)) : this.isIntersecting ? 1 : 0
          }
          function e(e, t) {
            var n,
              r,
              o,
              t = t || {}
            if ('function' != typeof e) throw new Error('callback must be a function')
            if (t.root && 1 != t.root.nodeType && 9 != t.root.nodeType)
              throw new Error('root must be a Document or Element')
            ;((this._checkForIntersections =
              ((n = this._checkForIntersections.bind(this)),
              (r = this.THROTTLE_TIMEOUT),
              (o = null),
              function () {
                o =
                  o ||
                  setTimeout(function () {
                    ;(n(), (o = null))
                  }, r)
              })),
              (this._callback = e),
              (this._observationTargets = []),
              (this._queuedEntries = []),
              (this._rootMarginValues = this._parseRootMargin(t.rootMargin)),
              (this.thresholds = this._initThresholds(t.threshold)),
              (this.root = t.root || null),
              (this.rootMargin = this._rootMarginValues
                .map(function (e) {
                  return e.value + e.unit
                })
                .join(' ')),
              (this._monitoringDocuments = []),
              (this._monitoringUnsubscribes = []))
          }
          function a(e, t, n, r) {
            'function' == typeof e.addEventListener
              ? e.addEventListener(t, n, r || !1)
              : 'function' == typeof e.attachEvent && e.attachEvent('on' + t, n)
          }
          function c(e, t, n, r) {
            'function' == typeof e.removeEventListener
              ? e.removeEventListener(t, n, r || !1)
              : 'function' == typeof e.detachEvent && e.detachEvent('on' + t, n)
          }
          function w(e) {
            var t
            try {
              t = e.getBoundingClientRect()
            } catch (e) {}
            return t
              ? t.width && t.height
                ? t
                : {
                    top: t.top,
                    right: t.right,
                    bottom: t.bottom,
                    left: t.left,
                    width: t.right - t.left,
                    height: t.bottom - t.top
                  }
              : d()
          }
          function d() {
            return { top: 0, bottom: 0, left: 0, right: 0, width: 0, height: 0 }
          }
          function r(e) {
            return !e || 'x' in e
              ? e
              : {
                  top: e.top,
                  y: e.top,
                  bottom: e.bottom,
                  left: e.left,
                  x: e.left,
                  right: e.right,
                  width: e.width,
                  height: e.height
                }
          }
          function g(e, t) {
            var n = t.top - e.top,
              e = t.left - e.left
            return {
              top: n,
              left: e,
              height: t.height,
              width: t.width,
              bottom: n + t.height,
              right: e + t.width
            }
          }
          function o(e, t) {
            for (var n = t; n; ) {
              if (n == e) return !0
              n = y(n)
            }
            return !1
          }
          function y(e) {
            var t = e.parentNode
            return 9 == e.nodeType && e != p
              ? i(e)
              : (t = t && t.assignedSlot ? t.assignedSlot.parentNode : t) &&
                  11 == t.nodeType &&
                  t.host
                ? t.host
                : t
          }
          function s(e) {
            return e && 9 === e.nodeType
          }
          'object' == typeof window &&
            ('IntersectionObserver' in window &&
            'IntersectionObserverEntry' in window &&
            'intersectionRatio' in window.IntersectionObserverEntry.prototype
              ? 'isIntersecting' in window.IntersectionObserverEntry.prototype ||
                Object.defineProperty(
                  window.IntersectionObserverEntry.prototype,
                  'isIntersecting',
                  {
                    get: function () {
                      return 0 < this.intersectionRatio
                    }
                  }
                )
              : ((p = (function () {
                  for (var e = window.document, t = i(e); t; ) t = i((e = t.ownerDocument))
                  return e
                })()),
                (n = []),
                (b = h = null),
                (e.prototype.THROTTLE_TIMEOUT = 100),
                (e.prototype.POLL_INTERVAL = null),
                (e.prototype.USE_MUTATION_OBSERVER = !0),
                (e._setupCrossOriginUpdater = function () {
                  return (h =
                    h ||
                    function (e, t) {
                      ;((b = e && t ? g(e, t) : d()),
                        n.forEach(function (e) {
                          e._checkForIntersections()
                        }))
                    })
                }),
                (e._resetCrossOriginUpdater = function () {
                  b = h = null
                }),
                (e.prototype.observe = function (t) {
                  var e = this._observationTargets.some(function (e) {
                    return e.element == t
                  })
                  if (!e) {
                    if (!t || 1 != t.nodeType) throw new Error('target must be an Element')
                    ;(this._registerInstance(),
                      this._observationTargets.push({ element: t, entry: null }),
                      this._monitorIntersections(t.ownerDocument),
                      this._checkForIntersections())
                  }
                }),
                (e.prototype.unobserve = function (t) {
                  ;((this._observationTargets = this._observationTargets.filter(function (e) {
                    return e.element != t
                  })),
                    this._unmonitorIntersections(t.ownerDocument),
                    0 == this._observationTargets.length && this._unregisterInstance())
                }),
                (e.prototype.disconnect = function () {
                  ;((this._observationTargets = []),
                    this._unmonitorAllIntersections(),
                    this._unregisterInstance())
                }),
                (e.prototype.takeRecords = function () {
                  var e = this._queuedEntries.slice()
                  return ((this._queuedEntries = []), e)
                }),
                (e.prototype._initThresholds = function (e) {
                  e = e || [0]
                  return (e = Array.isArray(e) ? e : [e]).sort().filter(function (e, t, n) {
                    if ('number' != typeof e || isNaN(e) || e < 0 || 1 < e)
                      throw new Error('threshold must be a number between 0 and 1 inclusively')
                    return e !== n[t - 1]
                  })
                }),
                (e.prototype._parseRootMargin = function (e) {
                  e = (e || '0px').split(/\s+/).map(function (e) {
                    e = /^(-?\d*\.?\d+)(px|%)$/.exec(e)
                    if (e) return { value: parseFloat(e[1]), unit: e[2] }
                    throw new Error('rootMargin must be specified in pixels or percent')
                  })
                  return ((e[1] = e[1] || e[0]), (e[2] = e[2] || e[0]), (e[3] = e[3] || e[1]), e)
                }),
                (e.prototype._monitorIntersections = function (t) {
                  var n,
                    r,
                    o,
                    e = t.defaultView
                  e &&
                    -1 == this._monitoringDocuments.indexOf(t) &&
                    ((n = this._checkForIntersections),
                    (o = r = null),
                    this.POLL_INTERVAL
                      ? (r = e.setInterval(n, this.POLL_INTERVAL))
                      : (a(e, 'resize', n, !0),
                        a(t, 'scroll', n, !0),
                        this.USE_MUTATION_OBSERVER &&
                          'MutationObserver' in e &&
                          (o = new e.MutationObserver(n)).observe(t, {
                            attributes: !0,
                            childList: !0,
                            characterData: !0,
                            subtree: !0
                          })),
                    this._monitoringDocuments.push(t),
                    this._monitoringUnsubscribes.push(function () {
                      var e = t.defaultView
                      ;(e && (r && e.clearInterval(r), c(e, 'resize', n, !0)),
                        c(t, 'scroll', n, !0),
                        o && o.disconnect())
                    }),
                    (e = (this.root && (this.root.ownerDocument || this.root)) || p),
                    t != e) &&
                    (e = i(t)) &&
                    this._monitorIntersections(e.ownerDocument)
                }),
                (e.prototype._unmonitorIntersections = function (r) {
                  var o,
                    e,
                    t = this._monitoringDocuments.indexOf(r)
                  ;-1 == t ||
                    ((o = (this.root && (this.root.ownerDocument || this.root)) || p),
                    this._observationTargets.some(function (e) {
                      if ((t = e.element.ownerDocument) == r) return !0
                      for (; t && t != o; ) {
                        var t,
                          n = i(t)
                        if ((t = n && n.ownerDocument) == r) return !0
                      }
                      return !1
                    })) ||
                    ((e = this._monitoringUnsubscribes[t]),
                    this._monitoringDocuments.splice(t, 1),
                    this._monitoringUnsubscribes.splice(t, 1),
                    e(),
                    r != o && (t = i(r)) && this._unmonitorIntersections(t.ownerDocument))
                }),
                (e.prototype._unmonitorAllIntersections = function () {
                  var e = this._monitoringUnsubscribes.slice(0)
                  this._monitoringDocuments.length = 0
                  for (var t = (this._monitoringUnsubscribes.length = 0); t < e.length; t++) e[t]()
                }),
                (e.prototype._checkForIntersections = function () {
                  var c, s
                  ;(this.root || !h || b) &&
                    ((c = this._rootIsInDom()),
                    (s = c ? this._getRootRect() : d()),
                    this._observationTargets.forEach(function (e) {
                      var t = e.element,
                        n = w(t),
                        r = this._rootContainsTarget(t),
                        o = e.entry,
                        i = c && r && this._computeTargetAndRootIntersection(t, n, s),
                        a = null,
                        e =
                          (this._rootContainsTarget(t) ? (h && !this.root) || (a = s) : (a = d()),
                          (e.entry = new u({
                            time: window.performance && performance.now && performance.now(),
                            target: t,
                            boundingClientRect: n,
                            rootBounds: a,
                            intersectionRect: i
                          })))
                      o
                        ? c && r
                          ? this._hasCrossedThreshold(o, e) && this._queuedEntries.push(e)
                          : o && o.isIntersecting && this._queuedEntries.push(e)
                        : this._queuedEntries.push(e)
                    }, this),
                    this._queuedEntries.length) &&
                    this._callback(this.takeRecords(), this)
                }),
                (e.prototype._computeTargetAndRootIntersection = function (e, t, n) {
                  if ('none' != window.getComputedStyle(e).display) {
                    for (var r, o, i = t, a = y(e), c = !1; !c && a; ) {
                      var s,
                        u,
                        d,
                        f = null,
                        l = 1 == a.nodeType ? window.getComputedStyle(a) : {}
                      if ('none' == l.display) return null
                      if (
                        (a == this.root || 9 == a.nodeType
                          ? ((c = !0),
                            a == this.root || a == p
                              ? h && !this.root
                                ? !b || (0 == b.width && 0 == b.height)
                                  ? (i = f = a = null)
                                  : (f = b)
                                : (f = n)
                              : ((s = (d = y(a)) && w(d)),
                                (u = d && this._computeTargetAndRootIntersection(d, s, n)),
                                s && u ? ((a = d), (f = g(s, u))) : (i = a = null)))
                          : a != (d = a.ownerDocument).body &&
                            a != d.documentElement &&
                            'visible' != l.overflow &&
                            (f = w(a)),
                        f &&
                          ((s = f),
                          (u = i),
                          (o = r = f = l = void 0),
                          (l = Math.max(s.top, u.top)),
                          (f = Math.min(s.bottom, u.bottom)),
                          (r = Math.max(s.left, u.left)),
                          (s = Math.min(s.right, u.right)),
                          (o = f - l),
                          (i =
                            0 <= (u = s - r) && 0 <= o
                              ? { top: l, bottom: f, left: r, right: s, width: u, height: o }
                              : null)),
                        !i)
                      )
                        break
                      a = a && y(a)
                    }
                    return i
                  }
                }),
                (e.prototype._getRootRect = function () {
                  var e, t
                  return (
                    (t =
                      this.root && !s(this.root)
                        ? w(this.root)
                        : ((t = (e = s(this.root) ? this.root : p).documentElement),
                          (e = e.body),
                          {
                            top: 0,
                            left: 0,
                            right: t.clientWidth || e.clientWidth,
                            width: t.clientWidth || e.clientWidth,
                            bottom: t.clientHeight || e.clientHeight,
                            height: t.clientHeight || e.clientHeight
                          })),
                    this._expandRectByRootMargin(t)
                  )
                }),
                (e.prototype._expandRectByRootMargin = function (n) {
                  var e = this._rootMarginValues.map(function (e, t) {
                      return 'px' == e.unit
                        ? e.value
                        : (e.value * (t % 2 ? n.width : n.height)) / 100
                    }),
                    e = {
                      top: n.top - e[0],
                      right: n.right + e[1],
                      bottom: n.bottom + e[2],
                      left: n.left - e[3]
                    }
                  return ((e.width = e.right - e.left), (e.height = e.bottom - e.top), e)
                }),
                (e.prototype._hasCrossedThreshold = function (e, t) {
                  var n = e && e.isIntersecting ? e.intersectionRatio || 0 : -1,
                    r = t.isIntersecting ? t.intersectionRatio || 0 : -1
                  if (n !== r)
                    for (var o = 0; o < this.thresholds.length; o++) {
                      var i = this.thresholds[o]
                      if (i == n || i == r || i < n != i < r) return !0
                    }
                }),
                (e.prototype._rootIsInDom = function () {
                  return !this.root || o(p, this.root)
                }),
                (e.prototype._rootContainsTarget = function (e) {
                  var t = (this.root && (this.root.ownerDocument || this.root)) || p
                  return o(t, e) && (!this.root || t == e.ownerDocument)
                }),
                (e.prototype._registerInstance = function () {
                  n.indexOf(this) < 0 && n.push(this)
                }),
                (e.prototype._unregisterInstance = function () {
                  var e = n.indexOf(this)
                  ;-1 != e && n.splice(e, 1)
                }),
                (window.IntersectionObserver = e),
                (window.IntersectionObserverEntry = u)))
        })()
      }
    ])

    if (window.WebfunnyEvents && window.WebfunnyEvents.init) {
      // @ts-ignore
      window.WebfunnyEvents.init({
        projectVersion: param.projectVersion,
        env: param.env,
        setting: param.setting
      })
    }

    if (window.WebfunnyEvents && window.WebfunnyEvents.setWfCookie) {
      // @ts-ignore
      window.WebfunnyEvents.setWfCookie(
        'initPoints',
        JSON.stringify(param.initPoints || {}),
        new Date().getTime() + 30 * 24 * 3600 * 1000
      )
    }
  }
}
// 埋点数据处理
window.webfunnyEvent = function (pointId) {
  //  你可以判断环境变量，选择性上报
  if (process.env.NODE_ENV === 'development') {
    return {
      trackEvent: () => {
        // console.log('开发环境，埋点不上报')
      }
    }
  }

  if (window._webfunnyEvent && typeof window._webfunnyEvent === 'function') {
    return window._webfunnyEvent(pointId)
  } else {
    console.warn('SDK未加载或异常，请检查！')
    return {
      trackEvent: function () {}
    }
  }
}
